class WIquickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleQuickAdd();
  }

  handleQuickAdd() {
    let varBtns = this.querySelectorAll('.WI_quickAdd_atc');

    const selectElement = this.querySelector('.WI_completeLook_options');
    const quickAddBtn = this.querySelector('.WI_quickAdd_atc');

    if (selectElement && quickAddBtn) {
      selectElement.addEventListener('change', function () {
        quickAddBtn.setAttribute("data-variantid", this.value);
      });
    }

    varBtns.forEach(variant => {
      variant.addEventListener('click', async (e) => {
        e.preventDefault();

        let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
        let emptyCart = document.querySelector('.WI_cartDrawerin_cart_empty');

        if (loadingCartBlock) loadingCartBlock.style.display = "block";
        if (emptyCart) emptyCart.style.display = "none";


        document.dispatchEvent(new CustomEvent("opencart", { bubbles: true }));

        let variantId = variant.getAttribute('data-variantid');
        if (!variantId) return; // Prevent empty variant add

        let formData = {
          items: [{ id: variantId, quantity: 1 }]
        };

        await fetch('/cart/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        document.dispatchEvent(new CustomEvent("updateCart", { bubbles: true }));
      });
    });
  }
}

customElements.define("wi-quickadd", WIquickAdd);
